import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from './utils';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    constructor(
        private http: HttpClient,
        private _utils: Utils
    ) { }

    getPayments(page: number = 0, size: number = 10, filter: any = {}, sort?: string, sort_order?: string): Promise<{ data: any[], total: number }> {
        return this.http.post<{ data: any[], total: number }>(
            `${this._utils.backURL}/api/admin/getter/payment?size=${size}&page=${page}&sort=${sort}&sort_order=${sort_order}`,
            filter,
            this._utils.jwt()
        ).toPromise();
    }

    getStats(): Promise<any> {
        return this.http.get<any>(
            `${this._utils.backURL}/api/admin/payment/stats`,
            this._utils.jwt()
        ).toPromise();
    }

    getWithdrawalsStats(): Promise<any> {
        return this.http.get<any>(
            `${this._utils.backURL}/api/admin/payment/withdrawals/stats`,
            this._utils.jwt()
        ).toPromise();
    }

    getNetStats(): Promise<any> {
        return this.http.get<any>(
            `${this._utils.backURL}/api/admin/payment/net/stats`,
            this._utils.jwt()
        ).toPromise();
    }
}
